import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { useAddPropertyImageMutation } from '../../../lib/apiSlice/property/propertySlice.tsx';

const ImageUploadForm = ({ apartmentId }) => {
    const [images, setImages] = useState([]);
    const [addPropertyImage, { isLoading }] = useAddPropertyImageMutation();

    const handleButtonClick = () => {
        document.getElementById('imageUpload').click();
    };

    const handleChange = (event) => {
        const selectedImages = Array.from(event.target.files);
        if (selectedImages.length > 0) {
            setImages(selectedImages);
        } else {
            toast.error('Kindly select image(s)!');
        }
    };

    const handleRemoveImage = (index) => {
        setImages(images.filter((_, i) => i !== index));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            if (images.length === 0) {
                toast.error('Please select at least one image');
                return;
            }
            for (const img of images) {
                const formData = new FormData();
                formData.append('apartment', apartmentId);
                formData.append('image', img);
                await addPropertyImage({ id: apartmentId, bodyData: formData }).unwrap();
            }
            toast.success('Successfully Added Property Images!');
            setImages([]);
        }
        catch (error) {
            toast.error('Error uploading images!');
        }
    };

    return (
        <form onSubmit={handleSubmit} encType='multipart/form-data' className="w-full">
            <div className="flex flex-col items-start gap-4">
                <button
                    type="button"
                    className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 mt-3"
                    onClick={handleButtonClick}
                >
                    Choose images to upload
                </button>
                <input
                    type='file'
                    id='imageUpload'
                    accept='image/*'
                    multiple
                    style={{ display: 'none' }}
                    onChange={handleChange}
                />

                {images.length > 0 && (
                    <>
                        <div className="flex w-full overflow-x-auto gap-4 py-2">
                            {images.map((image, index) => (
                                <div key={index} className="relative flex-shrink-0">
                                    <button
                                        type="button"
                                        onClick={() => handleRemoveImage(index)}
                                        className="absolute top-2 right-2 bg-red-600 rounded-full p-2 hover:bg-red-700 z-10"
                                    >
                                        <i className="bi bi-trash-fill text-white"></i>
                                    </button>
                                    <img
                                        src={URL.createObjectURL(image)}
                                        alt={`preview_${index}`}
                                        className="rounded shadow object-cover"
                                        style={{ width: "160px", height: "120px" }}
                                    />
                                </div>
                            ))}
                        </div>
                        <div className="w-full mt-4">
                            <button
                                type='submit'
                                className={`bg-green-600 text-white px-6 py-2 rounded hover:bg-green-700 transition ${isLoading ? 'opacity-50 cursor-not-allowed' : ''}`}
                                disabled={images.length === 0 || isLoading}
                            >
                                {isLoading ? 'Uploading...' : 'Upload Images'}
                            </button>
                        </div>
                    </>
                )}
            </div>
        </form>
    );
};

export default ImageUploadForm;